// extracted by mini-css-extract-plugin
module.exports = {"description":"styles-module__description___3j8b-","flex":"styles-module__flex___RxSXP"};